import Validator from "./Validator";

export default class JsonEntitiesEntityDataCardContentRowsRowComponentsComponentConfigValidator extends Validator {
    constructor() {
        super();
        this.validationRules = {
            type: 'object',
            empty: false,
            mandatory: false,
            attributes: {
                direction: {
                    type: 'string',
                    empty: false,
                    mandatory: false,
                },
                ggb: {
                    type: 'object',
                    empty: false,
                    mandatory: false,
                }
            }
        };
    }
}
